import { createFileRoute } from '@tanstack/react-router';
import { requireWorkstation } from '../../../../utils/workstationGuard';
import { lazy, Suspense } from 'react';
import Loading from '../../../../pages/Loading/Loading';

const HelpBoard = lazy(() => import('../../../../pages/HelpBoard/HelpBoard'));

export const Route = createFileRoute('/$lang/_authenticated/help-board')({
  beforeLoad: requireWorkstation,
  component: () => (
    <Suspense fallback={<Loading />}>
      <HelpBoard />
    </Suspense>
  ),
});
